export default __webpack_public_path__ + "static/media/home-circles-right.5945f3f2.svg";